import React from 'react'
import '../App.css'

function Footer() {
  return (
      <footer className='footer bg-dark text-light text-center py-3'>
        <p className='mb-0'>
            © 2024 Travel Snapshot Journal. All Rights Reserved.
        </p>
        <p className='mb-0'>
            Made with ❤️ in Visakhapatnam.
        </p>
      </footer>
  )
}

export default Footer
